import { ProductModel } from '../Services/CloudDB/Contract';

export class DevConfig {
    public static HIDE_HOOK_BOOSTER = true;
    public static HIDE_ACTIONS = false;
    public static HIDE_HOOPS_TIMER = false;
    public static PICTURE_GRAYSCALE_IS_BRIGHTER = true;
    public static VIEWPORT_ANIMTIONS_ON = true;
    public static HIDE_BOOSTER_HELP = true;
    public static HIDE_ALBUM_PAGE_TIMER = true;
    public static HIDE_ALBUM_GLORIA = true;

    public static LIVES_ON = false;

    private static timerId;
    private static textarea: HTMLDivElement | undefined;

    public static log(...args): void {
        let ta = DevConfig.textarea;
        if (!ta) {
            const rect = document.body.getBoundingClientRect();
            ta = document.createElement('div');
            ta.appendChild(document.createElement('ol'));
            ta.style.backgroundColor = '#ffffff';
            ta.style.position = 'absolute';
            ta.style.left = '10px';
            ta.style.top = '10px';
            ta.style.overflow = 'auto';
            ta.style.width = `${rect.width - 40}px`;
            ta.style.height = `${rect.height / 2}px`;
            document.body.appendChild(ta);
            DevConfig.textarea = ta;
        }

        ta.style.display = 'block';
        clearTimeout(DevConfig.timerId);
        DevConfig.timerId = setTimeout(() => {
            ta.style.display = 'none';
        }, 4000);

        const ul = ta.querySelector('ol');
        const li = document.createElement("li");
        li.appendChild(document.createTextNode(args.join(', ')));
        ul.appendChild(li);

        ta.scrollTop = Number.MAX_VALUE;
    }
}

export const devShopConfig = () => {
    return {
        livesShop: <Array<ProductModel>>[
            {
                id: '0',
                type: 'card_life__type_1',
                sticker: 'without_sticker',
                modifiers: {
                    coins: -99,
                    lives: 1,
                },
            },
            {
                id: '1',
                type: 'card_life__type_2',
                sticker: 'benefit',
                stickerInfo: '20%',
                modifiers: {
                    coins: -159,
                    lives: 3,
                },
            },
            {
                id: '3',
                type: 'card_life__type_3',
                sticker: 'player_choose',
                modifiers: {
                    coins: -299,
                    lives: 5,
                },
            },
            {
                id: '4',
                type: 'card_unlim_life__type_1',
                sticker: 'without_sticker',
                modifiers: {
                    coins: -299,
                    unlimLives: 60 * 60 * 1000,
                },
            },
            {
                id: '5',
                type: 'card_unlim_life__type_2',
                sticker: 'benefit',
                stickerInfo: '20%',
                modifiers: {
                    coins: -999,
                    unlimLives: 3 * 60 * 60 * 1000,
                },
            },
            {
                id: '6',
                type: 'card_unlim_life__type_3',
                sticker: 'player_choose',
                modifiers: {
                    coins: -2999,
                    unlimLives: 24 * 60 * 60 * 1000,
                },
            },
        ]
    }
}
